"use client";

import { useReportWebVitals } from "next/web-vitals";
import { BASE_URL } from "@/lib/api";

const SUPPORTED_WEB_VITALS = new Set(["CLS", "FCP", "INP", "LCP", "TTFB"]);

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    if (!SUPPORTED_WEB_VITALS.has(metric.name)) return;

    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating.toUpperCase().replace("-", "_"),
      id: metric.id,
      navigationType: metric.navigationType,
    });
    const url = `${BASE_URL}operations/web-vitals`;
    if (
      !navigator.sendBeacon(url, new Blob([body], { type: "application/json" }))
    )
      void fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body,
        keepalive: true,
      });
  });
  return null;
}
